module.exports = __webpack_public_path__ + "static/media/sort-amount-up-alt.6d6ca74f.svg";